/**
 * @flow
 * @relayHash 4cd441091757726639e63624e2380195
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ChooseSiteModalMutationVariables = {|
  id: number
|};
export type ChooseSiteModalMutationResponse = {|
  +setHomeSite: ?{|
    +ok: ?boolean
  |}
|};
export type ChooseSiteModalMutation = {|
  variables: ChooseSiteModalMutationVariables,
  response: ChooseSiteModalMutationResponse,
|};
*/


/*
mutation ChooseSiteModalMutation(
  $id: Int!
) {
  setHomeSite(tenantId: $id) {
    ok
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "Int!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "setHomeSite",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "tenantId",
        "variableName": "id",
        "type": "Int!"
      }
    ],
    "concreteType": "SetHomeSiteMutation",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "ok",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "ChooseSiteModalMutation",
  "id": "7a75abed6c6e2030d4bf21522dd72939",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "ChooseSiteModalMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "ChooseSiteModalMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
node.text = "mutation ChooseSiteModalMutation(\n  $id: Int!\n) {\n  setHomeSite(tenantId: $id) {\n    ok\n  }\n}\n";
(node/*: any*/).hash = '31f39594b63c5ad4f799826829838bc0';
module.exports = node;
